import { render, staticRenderFns } from "./BaseReminderCard.vue?vue&type=template&id=e1acf334"
import script from "./BaseReminderCard.vue?vue&type=script&lang=js"
export * from "./BaseReminderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports